import { defineNuxtPlugin, useCookie, refreshCookie } from 'nuxt/app'

declare module 'nuxt/app' {
  interface NuxtApp {
    $cookies: typeof useCookie
    $refreshCookie: typeof refreshCookie
  }
}

export default defineNuxtPlugin({
  name: 'cookies-provider:plugin',
  setup(ctx) {
    return {
      provide: {
        cookies: (...args: Parameters<typeof useCookie>) => {
          const currentCtx = tryUseNuxtApp()
          if (currentCtx) {
            return useCookie(...args)
          }
          return ctx.runWithContext(() => useCookie(...args))
        },
        refreshCookie: (...args: Parameters<typeof refreshCookie>) => {
          const currentCtx = tryUseNuxtApp()
          if (currentCtx) {
            return refreshCookie(...args)
          }
          return ctx.runWithContext(() => refreshCookie(...args))
        },
      },
    }
  },
})
